import React from 'react';
interface SectionHeadingProps {
  overline?: string;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  align?: 'center' | 'left';
  tone?: 'light' | 'dark';
  size?: 'md' | 'lg';
  className?: string;
}
export function SectionHeading({
  overline,
  title,
  subtitle,
  align = 'center',
  tone = 'light',
  size = 'md',
  className = ''
}: SectionHeadingProps) {
  const isCenter = align === 'center';
  const isDark = tone === 'dark';
  const titleSize = size === 'lg' ? 'text-[1.95rem] sm:text-[2.9rem] lg:text-[3.4rem]' : 'text-[1.7rem] sm:text-[2.4rem] lg:text-[3rem]';
  return <div className={`${isCenter ? 'mx-auto max-w-3xl text-center' : 'max-w-2xl text-left'} ${className}`} data-id="element-217" data-mp="d8bx0bk1a33l">
      {overline ? <p className={`flex items-center gap-2.5 text-[10px] font-semibold uppercase tracking-[0.18em] sm:gap-3 sm:text-[11px] sm:tracking-overline ${isDark ? 'text-gold-200' : 'text-gold-600'} ${isCenter ? 'justify-center' : ''}`} data-id="element-218" data-mp="8atlqeijnbsf">
          <span className={`h-px w-7 ${isDark ? 'bg-gold-400/50' : 'bg-gold-200'}`} aria-hidden="true" data-id="element-219" data-mp="3vf9q5jgkincb" />
          {overline}
          <span className={`h-px w-7 ${isDark ? 'bg-gold-400/50' : 'bg-gold-200'}`} aria-hidden="true" data-id="element-220" data-mp="1ir9bdm0ot6uo" />
        </p> : null}

      <h2 className={`mt-4 font-serif leading-[1.12] sm:mt-5 sm:leading-[1.06] ${titleSize} ${isDark ? 'text-cream' : 'text-sage-800'}`} style={{
      fontWeight: "600"
    }} data-id="element-221" data-mp="150eaavwfju1n">
        {title}
      </h2>

      {subtitle ? <p className={`mt-4 text-[14.5px] leading-relaxed sm:mt-5 sm:text-[17px] ${isDark ? 'text-sage-100' : 'text-ink-soft'} ${isCenter ? 'mx-auto max-w-2xl' : ''}`} data-id="element-222" data-mp="1wqsl2j95cq93">
          {subtitle}
        </p> : null}
    </div>;
}